import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";

/** Running inside a Capacitor native shell (iOS/Android) vs a browser. */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/** `"ios" | "android" | "web"` — the concrete platform (drives StatusBar/Keyboard/push behavior). */
export function getPlatform(): string {
  return Capacitor.getPlatform();
}

/**
 * The installed app's build number (iOS `CFBundleVersion` — the pipeline IID, or a timestamp on a local build),
 * or null on web or when the native read fails. The client-version headers carry it so the API can refuse a
 * binary below the minimum it still serves. Kept behind this seam so apps/core never imports @capacitor/app.
 */
export async function getNativeBuild(): Promise<string | null> {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const { build } = await App.getInfo();
    return build || null;
  } catch {
    return null;
  }
}

/** The installed app's marketing version (iOS `CFBundleShortVersionString`, e.g. "1.1.1"), or null on web or when
 * the native read fails. Display only — the version gate keys off {@link getNativeBuild}. */
export async function getNativeVersion(): Promise<string | null> {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const { version } = await App.getInfo();
    return version || null;
  } catch {
    return null;
  }
}
